import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material'
import React from 'react';

import NewspaperIcon from '@mui/icons-material/Newspaper';
import ForumIcon from '@mui/icons-material/Forum';
import SchoolIcon from '@mui/icons-material/School';
import InfoIcon from '@mui/icons-material/Info';
import GavelIcon from '@mui/icons-material/Gavel';
// import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
// import AddModeratorIcon from '@mui/icons-material/AddModerator';
import colors from '../../../assets/theme/base/colors';
import { Link } from 'react-router-dom';

const { dark, primary } = colors;

export const ModuleRedirectCards = () => {

    const renderCard = (label: string, icon: JSX.Element, toComponentUrl: string) => {
        return (
            <Grid item xs={3} padding={0.5}>
                <CardActionArea component={Link} to={toComponentUrl} sx={{ width: "100%", height: "100%", borderRadius: 3 , border: `2px solid #eae9e9`,}}>
                    <Card sx={{ height: "100px", justifyContent: "center" }} >
                        <CardContent sx={{ width: "100%" }}>
                            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" width="100%">
                                <Typography variant='h5' color={dark.main} mr={1}>{label}</Typography>
                                {icon}
                            </Box>
                        </CardContent>
                    </Card>
                </CardActionArea>
            </Grid >
        )
    }

    return (
        <Card sx={{border : `2px solid ${primary.main}`}}>
            <CardContent>
                <Typography variant="h5" color="primary"> The Forum </Typography>
                <Grid container sx={{ borderRadius: 3, borderColor: "#7f7f7f" }}>
                    {renderCard("Academy", <SchoolIcon sx={{ color: dark.main }} />, "/academy/digitalContent")}
                    {/* {renderCard("Forum", <ForumIcon sx={{ color: dark.main }} />, "beeForum")} */}
                    {renderCard("Updates", <InfoIcon sx={{ color: dark.main }} />, "/whatsNew")}
                    {renderCard("News", <NewspaperIcon sx={{ color: dark.main }} />, "/news")}
                    {renderCard("Legislation", <GavelIcon sx={{ color: dark.main }} />, "/legislation/B-BBEE")}
                    {/* {renderCard("Template Library", <LocalLibraryIcon sx={{ color: dark.main }} />, "")} */}
                    {/* {renderCard("Partner Verification Agencies", <AddModeratorIcon sx={{ color: dark.main }} />, "")} */}
                </Grid>
            </CardContent>
        </Card>
    )
}
